import React, { useEffect, useState } from "react";
import LeftMenu from "../../AnalyticsModule/Left";
import { RunnerUpHeader } from "../../../ui";
import { useGetDetailedEciReportMutation,  useGetSummaryEciReportMutation } from "../../../services/reportsServices";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils";
import report from "../../../dashboardicon/report.svg";
import MultiSelectCheckBox from "../../../ui/multiSelectCheckbox/MultiSelectCheckBox";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";


const header = [
    "Phase No",
  "State Code",
  "State Name",
  "Constituency Type",
  "Election Type",
  "Total Constituency ",
  "Total Pending",
  "Total Transmitted",
];

const header2 = [ 
    "Phase No",
    "State Code",
    "State Name",
    "Election Type",
    "Constituency No",
    "Constituency Type",
    "Transmitted",
]

const phaseList = [];

const PhaseWisePendencyreport = () => {
  const [getSummary, dataS] = useGetSummaryEciReportMutation();
  const [getDetailed, dataD] = useGetDetailedEciReportMutation();
  const [selected, setSelected] = useState([]);
  const [Error, setError] = useState({});

  useEffect(()=>{
   const Phases = JSON.parse(localStorage?.phaseList)
   Phases.map((item)=>{
    phaseList.push({value:item, label:item})
   })

  },[])
  
  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };


  const getDetailedReport = () => {
    let error = {};
    if (!selected || selected.length === 0) {
      error["phaseList"] = "This field is required";
    }

    if (Object.keys(error).length) {
      setError(error);
      return;
    }

    const data = [];
    selected.map((item) => data.push(item.value));
    
    getDetailed({phaseNo:data})
    .unwrap()
      .then((res) => {
        let tData = [];
        res?.payload?.map((item, i) => {
          tData.push({
            phaseNo:item.phaseNo,
            stateCd: item.stateCd,
            stateName:    item.stateName,
            electionType:    item.electionType,
            constNo :   item.constNo,
            constType :   item.constType,
            transmitted :   item.transmitted,
          });
        });
        downloadExcelFile(
            `e-PB Transmission Detailed Report Phase :${data.join("_")}`,
            "Detailed list",
            header2,
            tData,
            false,
            true,
            7
          );
      })
      .catch((error) => {
      });
      
  };

  const getSummaryReport = () => {
    let error = {};
    if (!selected || selected.length === 0) {
      error["phaseList"] = "This field is required";
    }

    if (Object.keys(error).length) {
      setError(error);
      return;
    }

    const data = [];
    selected.map((item) => data.push(item.value));
    getSummary({phaseNo:data})
    .unwrap()
      .then((res) => {
        let tData = [];
        res?.payload?.map((item, i) => {
          tData.push({
            phaseNo:item.phaseNo,
           stateCd:item.stateCd ,
           stateName:item.stateName ,
           constType:item.constType ,
 electionType:item.electionType ,
 total_Constituency:item.total_Constituency ,
 total_Pending:item.total_Pending ,
 total_Transmitted:item.total_Transmitted ,
          });
        });
        downloadExcelFile(
            `e-PB Transmission Summary Report Phase :${data.join("_")}`,
            "Summary list",
            header,
            tData,
          );
      })
      .catch((error) => {
      });
  };

  return (
    <LeftMenu>
      <div className="container box shadow ">
        <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={"Phase Wise e-PB Transmission Report"} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-2" style={{paddingRight:"0px"}}><p style={{textAlign:"right",paddingTop:"6px"}}>Select Phase</p></div>
          <div className="col-md-4">
            <MultiSelectCheckBox
              options={phaseList}
              name="phaseList"
              value={selected}
              className={"col-md-12"}
              onChange={setSelected}
              labelledBy="Select"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("phaseList", val)}
              Error={Error}
            ></MultiSelectCheckBox>
          </div>
          
          <div className="col-md-3  download_button">
            <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={() => getSummaryReport()}
            >
              Summary Report
              <span className="pl-2">
                <img
                  src={report}
                  alt=""
                  style={{ height: "25px", width: "25px" }}
                />
              </span>
            </button>
          </div>
          <div className="col-md-3 download_button">
            <button
              type="button"
              className="btn btn-danger btn-sm searchbuttonreport"
              onClick={() => getDetailedReport()}
            >
              Detailed Report
              <span className="pl-2">
                <img
                  src={report}
                  alt=""
                  style={{ height: "25px", width: "25px" }}
                />
              </span>
            </button>
          </div>
        </div>
      </div>
    </LeftMenu>
  );
};

export default PhaseWisePendencyreport;
